module.exports = __webpack_public_path__ + "img/swipe_animation.3f38f9a4.gif";